<template>
  <div v-if="shouldDisplay">
    <div v-if="item.entity_name" :class="itemSidebar" :id="item.entity_name + item.id">
      <div class="message-item">
        <div class="item-body container-fluid">
          <div class="row">
            <div class="col-xs-12 item-header">
              <div class="item-header-top">
                <img v-if="item.sender_type == 'User'" :src="item.sender.avatar_url" class="item-avatar">
                <img v-else-if="item.help_request" src="/static/images/teams-tiger-icon.png" class="item-avatar">
                <span v-else class="item-avatar-missing">
                  <a :href="`/customers/${item.sender.id}`" target="_blank">
                    <fa icon="user-circle" />
                  </a>
                </span>
                <div class="item-content-wrapper">
                  <span class="item-info">
                    <div>
                      <h4 class="sender">{{ senderName }}</h4>
                      <h6 v-if="show_message_id">Merged item from message: #{{item.message_id}}</h6>
                      <h6 :class="itemActionTextClass" class="action-text">{{ itemActionText }}</h6>
                      <span v-if="item.entity_name == 'MessageDraft'">
                        <b-button-group class="draft-buttons">
                          <b-button @click="editDraft(item)" variant="outline-secondary">Edit</b-button>
                          <b-button @click="discardDraft(item.id)" variant="outline-secondary">Discard</b-button>
                        </b-button-group>
                      </span>
                      <span v-else-if="(item.entity_name == 'Note') && (item.user_id == currentUser.id)">
                        <b-button-group class="draft-buttons">
                          <b-button @click="editNote(item)" variant="outline-secondary">Edit</b-button>
                          <b-button @click="discardNote(item.id)" variant="outline-secondary">Discard</b-button>
                        </b-button-group>
                      </span>
                    </div>
                  </span>
                  <div v-b-tooltip.hover.left :title="detailedDate(item.updated_at)"
                       class="top-header-right timestamp">
                    {{prettyDate(item.created_at)}}
                    <template v-if="!external && item.entity_name == 'MessageThread'">
                      <span v-if="item.opened_at">(Read)</span>
                      <span v-else>(Sent)</span>
                    </template>
                  </div>
                  <div class="top-header-right timestamp">
                  </div>
                  <div v-if="threadOrDraft" class="from-timestamp">
                    <div v-if="item.entity_name === 'MessageThread'"><b>From:</b> {{item.from_email[0]}}</div>
                    <div v-if="item.entity_name === 'MessageThread'"><b>Subject:</b> {{item.subject}}</div>
                    <div>
                      <b>To:</b>
                      <div v-for="email in item.to_email"
                           :key="email + item.id + item.entity_name + 'to'"
                          class="to-cc">
                        {{ email }}
                      </div>
                    </div>
                    <div v-if="item.cc">
                      <b>cc:</b>
                      <div v-for="(email, i) in item.cc"
                           :key="email + item.id + item.entity_name + 'cc' + i"
                          class="to-cc">
                        {{ email }}
                      </div>
                    </div>
                  </div>

                  <div v-if="item.body_html" class="col-xs-12 item-body" v-html="item.body_html"></div>
                  <div v-else-if="item.body_text" class="col-xs-12 item-body" v-html="item.body_text"></div>
                  <div v-else-if="item.content" class="col-xs-12 item-body" v-html="item.content"></div>
                  <div v-else-if="item.text" class="col-xs-12 item-body" v-html="item.text"></div>
                  <template v-if="hasAttachments">
                    <Attachments v-if="item.all_attachments.length > 0" :attachments="item.all_attachments" :control="false"/>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="item-hr">
    </div>
    <div v-else>
      <div v-if="item.display_text" class="message-item-audit">
        <MessageAudit :audit="item" />
        <hr class="item-hr">
      </div>
    </div>
  </div>
</template>

<script>
import Attachments from './Attachments'
import MessageAudit from './MessageAudit'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { helpersMixins } from '@/mixins/helpersMixins'
export default {
  name: 'MessageItem',
  mixins: [helpersMixins],
  props: {
    item: Object,
    mailbox_id: Number,
    draft_only: Boolean,
    show_message_id: Boolean,
    external: Boolean,
    draft_count: Number
  },
  components: {
    MessageAudit,
    Attachments
  },
  data () {
    return {
      hasImages: false,
      hasDocuments: false,
      hasAttachments: false
    }
  },
  created () {
    if (this.item.images && this.item.images.length > 0) {
      this.hasImages = true
    }
    if (this.item.documents && this.item.documents.length > 0) {
      this.hasDocuments = true
    }
    if (this.item.all_attachments && this.item.all_attachments.length > 0) {
      this.hasAttachments = true
    }
  },
  mounted () {
    this.messageSettings()
    this.collapseQuotes()
  },
  methods: {
    ...mapMutations(['setDraft']),
    ...mapActions(['deleteDraft']),
    editDraft (item) {
      this.setDraft({draft: item, parentMessageId: item.message_id})
      this.$root.$emit('draftEdit')
    },
    discardDraft (id) {
      var discard = confirm('Discard this draft?')
      if (discard === true) {
        this.deleteDraft(id)
          .then(function (response) {
            if (this.draft_only && this.draft_count <= 1) {
              this.$router.push('/inboxes/' + this.mailbox_id)
            } else {
              this.$store.dispatch('reloadMessage')
            }
          }.bind(this))
          .catch(e => { console.log(e.response) })
      }
    },
    editNote (item) {
      this.$root.$emit('noteEdit', item)
    },
    discardNote (id) {
      var discard = confirm('Discard this note?')
      if (discard === true) {
        this.$http.delete('/notes/' + id)
          .then(response => this.$store.dispatch('reloadMessage'))
          .catch(e => { console.log(e.response) })
      }
    },
    messageSettings () {
      var anchors = document.querySelectorAll('.message-item a')
      var anchors2 = document.querySelectorAll('.message-item img')
      for (var i = 0; i < anchors2.length; i++) {
        anchors2[i].classList.add('img-fluid')
      }
      for (var j = 0; j < anchors.length; j++) {
        anchors[j].setAttribute('target', '_blank')
      }
    },
    collapseQuotes () {
      if (this.item.entity_name !== 'MessageThread') {
        return
      }
      var parent = document.querySelector('#MessageThread' + this.item.id)
      var outlookParent = parent.querySelector('.WordSection1:first-of-type')
      var outlookItem = outlookParent ? outlookParent.querySelector('div:last-of-type') : null
      var quote = parent.querySelector('div.gmail_quote')

      if (quote) {
        var toggle = document.createElement('span')
        toggle.classList.add('oi', 'oi-ellipses', 'toggle-quote')
        quote.parentNode.insertBefore(toggle, quote)
        var ellipses = parent.querySelector('.oi.oi-ellipses.toggle-quote')
        ellipses.addEventListener('click', function () {
          var quotes = parent.querySelectorAll('div.gmail_quote')
          for (var i = 0; i < quotes.length; i++) {
            quotes[i].classList.toggle('quote-visible')
          }
        })
      }
      if (outlookItem) {
        var outlookSpan = document.createElement('span')
        outlookSpan.classList.add('oi', 'oi-ellipses', 'outlook-item')
        outlookItem.classList.add('outlook_quote')
        outlookItem.parentNode.insertBefore(outlookSpan, outlookItem)
        outlookParent.querySelector('.oi.oi-ellipses.outlook-item').addEventListener('click', function () {
          outlookItem.classList.toggle('quote-visible')
        })
      }
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' }),
    itemSidebar () {
      if (this.item.entity_name === 'MessageThread') {
        if (this.item.sender_type === 'User') {
          return 'outgoing-border'
        }
      } else if (this.item.entity_name === 'MessageDraft') {
        return 'draft-border'
      } else if (this.item.entity_name === 'Note') {
        return 'note-border'
      }
    },
    itemActionText () {
      if (this.item.entity_name === 'MessageThread') {
        if (this.item.is_oldest === true) {
          return 'started the conversation'
        } else {
          return 'replied'
        }
      } else if (this.item.entity_name === 'MessageDraft') {
        return 'created a draft'
      } else if (this.item.entity_name === 'Note') {
        return 'added a note'
      }
    },
    itemActionTextClass () {
      if (this.item.entity_name === 'MessageThread') {
        return 'thread-text'
      } else if (this.item.entity_name === 'MessageDraft') {
        return 'draft-text'
      } else if (this.item.entity_name === 'Note') {
        return 'note-text'
      }
    },
    threadOrDraft () {
      if (this.item.entity_name) {
        if (this.item.entity_name === 'MessageThread' || this.item.entity_name === 'MessageDraft') {
          return true
        }
      } else {
        return false
      }
    },
    senderName () {
      var currentUserId
      if (this.external) {
        currentUserId = 0
      } else {
        currentUserId = this.currentUser.id
      }
      if (this.item.sender_type === 'User' && this.item.sender.id === currentUserId) {
        return 'you'
      } else if ((this.item.sender_type === 'User' || this.item.sender_type === 'Customer') && this.item.sender.full_name) {
        return this.item.sender.full_name
      } else if (this.item.sender_type === 'System') {
        return 'Teams Tiger'
      } else {
        return this.item.from_email[0]
      }
    },
    shouldDisplay () {
      if (this.external) {
        if (this.item.entity_name && this.item.entity_name === 'MessageThread') {
          return true
        }
      } else {
        return true
      }
    }
  }
}
</script>

<style>
.message-item {
  width: 100%;
}
.item-header {
  width: 100%;
  text-align: left;
  margin-bottom: 5px;
}
.item-header-top {
  display: inline;
}
.item-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: top;
  font-size: 50px;
  float: left;
  margin: 25px 20px 25px 25px;
}
.item-avatar-missing {
  vertical-align: top;
  font-size: 50px;
  margin: 16px 20px 25px 30px;
  float: left;
}
.item-content-wrapper {
  margin-left: 72px;
  padding: 25px 28px;
  overflow: auto;
}
.item-info {
  display: inline-block;
}
.item-body {
  text-align: left;
}
.item-body .row {
  display: block;
}
.item-body p {
  margin-top: 0;
  margin-bottom: 0;
}
.message-thread-attachment {
  margin-top: 10px;
  text-align: left;
  width: 100%;
}
.from-timestamp {
  color: #7A858E;
  font-size: 12px;
}
.action-text {
  display: inline-block;
}
.to-cc {
  display: inline-block;
  margin-right: 5px;
}
.sender {
  display: inline-block;
  margin-right: 5px;
}
.item-hr {
  margin: 0;
}
.top-header-right {
  float: right;
}
.outgoing-border {
  border-left: 3px solid #6F6F6F;
}
.draft-border {
  border-left: 3px dashed #57B2CD;
}
.note-border {
  border-left: 3px solid #F5B126;
}
.thread-text {
  color: #7A858E;
}
.draft-text {
  color: #57B2CD;
}
.note-text {
  color: #F5B126;
}
.draft-buttons {
  margin-left: 5px;
}
.draft-buttons .btn {
  font-size: 13px;
  padding: 4px 8px;
  font-weight: 500;
}
.timestamp {
  font-size: 12px;
  color: #7A858E;
  padding-left: 5px;
}
div.gmail_quote, div.outlook_quote {
  display: none;
}
.gmail_quote.quote-visible, .outlook_quote.quote-visible {
  display: block !important;
}
.oi-ellipses.toggle-quote, .oi-ellipses.outlook-item {
  color: #000;
  padding: 1px 3px 0 3px;
  border-radius: 5px;
  line-height: .75;
  transition: all .3s ease-in-out;
  cursor: pointer;
}
.oi-ellipses.toggle-quote:hover {
  background-color: #DEDEDE;
  padding: 1px 3px 0 3px;
}
.item-avatar-missing a, .item-avatar-missing a:link, .item-avatar-missing a:visited, .item-avatar-missing a:focus, .item-avatar-missing a:hover {
  color: unset;
}
@media (max-width: 767px) {
  .item-content-wrapper {
    margin-left: 10px;
    padding: 10px 0 0 0;
    overflow: visible;
    word-break: break-word;
  }
  .item-avatar {
    width: 30px;
    height: 30px;
    margin: 10px;
  }
  .item-avatar-missing {
    font-size: 30px;
    margin: 3px 10px -7px 10px;
  }
  .item-header-top {
    display: inline-block;
    width: 100%;
  }
  h4.sender {
    font-size: 1.2rem;
  }
  h6.action-text {
    font-size: .9rem;
  }
  .top-header-right.timestamp {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MessageItem.vue